// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADMINCLUB_MENU = "Adminclub";
export const PROFILE_BLOCKED__HEADER_username = "U\u017eivatelce %(username)s byl zru\u0161en\u00fd profil";
export const PROFILE_BLOCKED__REASON1_kodex = "z d\u016fvodu poru\u0161en\u00ed %(kodex)s";
export const PROFILE_BLOCKED__REASON2 = "";
export const PROFILE_BLOCKED__REASON3 = "na z\u00e1klad\u011b podez\u0159en\u00ed z podvodn\u00fdch aktivit";
export const PROFILE_BLOCKED__REASON4 = "na vlastn\u00ed \u017e\u00e1dost";
export const PROFILE_BLOCKED__REASON5 = "vkl\u00e1d\u00e1n\u00ed nepovolen\u00e9 reklamy na str\u00e1nku";
export const PROFILE_BLOCKED__REASONS_ARE = "Profily jsou ru\u0161en\u00e9 hlavn\u011b z t\u011bchto d\u016fvod\u016f:";
export const PROFILE_username_BLOCKED_BY_USER = "U\u017eivatelka %(username)s u\u017e nem\u00e1 \u00fa\u010det na Modr\u00e9m kon\u00edku. K tomuto kroku se rozhodla a \u00fa\u010det si zru\u0161ila sama.";
export const RULES_KODEX__GENITIVE = "Kodexu chov\u00e1n\u00ed";
export const USER_UNLIKE = "Odeber z obl\u00edben\u00fdch";
